import React from 'react';

import authService from '../../services/authService';

const { __environment__ } = window as any;
const redirectURL = __environment__.REACT_APP_MOLINA_APP_URL;

const LoginCallback = (test: any) => {
  const [done, setDone] = React.useState(false);

  React.useEffect(() => {
    authService.handleLoginCallback(window.location.href).then((tokens) => {
      setDone(true);

      const url = `${redirectURL}/auth?accesstoken=${tokens?.accessToken}`;
      window.location.href = url;
    });
  }, []);

  if (!done) {
    return null;
  }

  return <div />;
};

export default LoginCallback;
